import React, { useState, useEffect } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import { Phone, MessageCircle } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';


const About = ({ showFooter = true }) => {
    const [showScrollTop, setShowScrollTop] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('opacity-100', 'translate-y-0');
                        entry.target.classList.remove('opacity-0', 'translate-y-5');
                    }
                });
            },
            { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
        );

        document.querySelectorAll('.feature-item').forEach((el) => {
            el.classList.add('opacity-0', 'translate-y-5', 'transition-all', 'duration-600', 'ease-in-out');
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Navbar />
            <section id="about" className="bg-gray-100 py-20">
                <div className="container mx-auto px-5">
                    <h2 className="text-center text-4xl mb-16 text-[#2c5530] font-bold relative after:content-[''] after:absolute after:bottom-[-10px] after:left-1/2 after:-translate-x-1/2 after:w-24 after:h-1 after:bg-gradient-to-r after:from-[#ff6b6b] after:to-[#ffa500] after:rounded">
                        About ReVa Industries
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                        <div className="text-lg leading-8 text-justify">
                            <p className=''>
                                Founded in 2020, Reva Industries is a leading manufacturer of high-quality LDPE extruded coated reels and paper blanks, made from 100% virgin fiber paper with 1PE or 2PE coating, perfect for industrial packaging and disposable paper cups. Ranging from 60 to 350 GSM, our advanced infrastructure with double-blade cutting machines ensures precision, quality, and innovative solutions.
                            </p>
                            <p>
                                Our mission is to maximize customer satisfaction by delivering superior materials and building trusted relationships.
                            </p>
                            <p>
                                Our vision is to set an industry benchmark with exceptional products that inspire confidence.
                            </p>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-8">
                            <div className="feature-item bg-white p-8 rounded-lg text-center shadow-lg hover:-translate-y-1 transition-transform">
                                <div className="text-5xl mb-4">🍵</div>
                                <h3 className="text-xl mb-2">Tea Optimized</h3>
                                <p>Specially designed for hot tea and chai</p>
                            </div>
                            <div className="feature-item bg-white p-8 rounded-lg text-center shadow-lg hover:-translate-y-1 transition-transform">
                                <div className="text-5xl mb-4">🔥</div>
                                <h3 className="text-xl mb-2">Heat Resistant</h3>
                                <p>Withstands high temperatures without leaking</p>
                            </div>
                            <div className="feature-item bg-white p-8 rounded-lg text-center shadow-lg hover:-translate-y-1 transition-transform">
                                <div className="text-5xl mb-4">💰</div>
                                <h3 className="text-xl mb-2">Affordable Bulk</h3>
                                <p>Competitive pricing for wholesale orders</p>
                            </div>
                            <div className="feature-item bg-white p-8 rounded-lg text-center shadow-lg hover:-translate-y-1 transition-transform">
                                <div className="text-5xl mb-4">🚚</div>
                                <h3 className="text-xl mb-2">Fast Supply</h3>
                                <p>Regular delivery schedules for vendors</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {showFooter && <Footer />}
            <div className="fixed bottom-5 right-5 flex flex-col gap-3 z-20">
                <a
                    href="tel:+919426788499"
                    className={`bg-sky-500 text-white w-12 h-12 rounded-lg text-xl flex items-center justify-center cursor-pointer hover:bg-sky-700 transition-all`}
                    title="Call Us"
                >
                    <Phone />
                </a>
                <a
                    href="https://wa.me/+919426788499"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`bg-[#3ed145] text-white w-12 h-12 rounded-lg text-xl flex items-center justify-center cursor-pointer hover:bg-[#2f8734] transition-all`}
                    title="Message on WhatsApp"
                >
                    <FaWhatsapp className='h-12 w-8' />
                </a>
            </div>
        </>
    );
};

export default About;